import { uniqBy } from 'lodash';
import { CustomSource, CustomSourceData } from '../../../custom_shared/types';
import { TypeUtils } from '../../../common/misc';
import { Filter } from '../../../common/services/SessionService';

export default abstract class SourceModelBase {
    readonly id: string;
    readonly type: string;

    constructor(data: CustomSource) {
        this.id = data.id;
        this.type = data.type;
    }

    protected filterData(data: CustomSourceData[]): CustomSourceData[] {
        return uniqBy(
            data.filter(d => TypeUtils.isString(d.value) && d.value.length > 0),
            'value'
        );
    }

    abstract getSources(ignoreCache?: boolean, filter?: Filter): Promise<CustomSourceData[]>;
}
